import BaseSlider from '../../common/components/sliders/components/BaseSlider';
import laptop from '../assets/icon/Laptop.png';
import addOn from '../assets/icon/Add-ons.png';
import calendar from '../assets/icon/Calendar.png';
import promotion from '../assets/icon/Promotions.png';
import catches from '../assets/icon/Catches.png';
import dashboard from '../assets/icon/Dashboard.png';
import member from '../assets/icon/Members.png';
import additionalDetails from '../assets/icon/AdditionalDetails.png';
import manageAccess from '../assets/icon/GateCodes.png';
import reporting from '../assets/icon/Reporting.png';

export function AdminFeatureSlider() {
  const breakpoints = {
    desktop: {
      breakpoint: { max: 10000, min: 1200 },
      items: 3,
      slidesToSlide: 2,
      partialVisibilityGutter: 0,
    },
    tablet: {
      breakpoint: { max: 1200, min: 670 },
      items: 2,
      slidesToSlide: 2,
      partialVisibilityGutter: 0,
    },
    mobile: {
      breakpoint: { max: 670, min: 300 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 30,
    },
    smallMobile: {
      breakpoint: { max: 300, min: 0 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 0,
    },
  };
  let info = [
    {
      image: dashboard,
      heading: 'Overview Dashboard',
      description: 'Complete business oversight on one screen',
    },
    {
      image: calendar,
      heading: 'Booking Calendar',
      description: 'Traffic light calendar system for easy management',
    },
    {
      heading: 'Upsell Products',
      image: addOn,
      mobileImage: true,
      description:
        'Sell products and services to anglers when they are booking',
    },
    {
      image: catches,
      heading: 'Catch Reports',
      description: 'Manage and share catch reports to your public profile',
    },
    {
      image: promotion,
      mobileImage: true,
      heading: 'Promotions',
      description: 'Create your own special offers and discounts for anglers',
    },
    {
      image: member,
      heading: 'Membership Management',
      description: 'Full membership management system',
    },
    {
      image: reporting,
      heading: 'KPI Reporting',
      description: 'Export reports and review business performance',
    },
    {
      image: manageAccess,
      heading: 'Manage access',
      description: 'Automatically deliver access codes to your anglers',
    },
    {
      image: additionalDetails,
      mobileImage: true,
      heading: 'Additional Booking Info',
      description: 'Request vehicle registration & other details',
    },
  ];

  return (
    <BaseSlider
      horizontal
      infinite={false}
      // hideButtons
      hideButtonsOnMobile
      className='feature-slider mg-bottom-50'
      breakpointsOverride={breakpoints}
      showPartialNext
      extra=''
      noHoverAnimation
    >
      {info?.map((info) => {
        return (
          <>
            {info?.mobileImage ? (
              <div className='bg-white br20  admin-feature-container-mobile  '>
                <div className='justify-between center h-full'>
                  <div className=''>
                    <div className='fs-12 gSemiBold row-center justify-between uppercase grey-600 mg-bottom-15'>
                      <div>{info?.heading}</div>
                      <div className='fs-12 br30 gBold txt-center included sb-blue-bg-100 center'>
                        INCLUDED
                      </div>
                    </div>
                    <div className='fs-20 gSemiBold txt-center grey-900'>
                      {info?.description}
                    </div>
                  </div>
                  {info?.image && (
                    <img src={info?.image} width='120%' alt='feature-image' />
                  )}
                </div>
              </div>
            ) : (
              <div className='bg-white br20  admin-feature-container  '>
                <div className='justify-between center h-full'>
                  <div className='px-20'>
                    <div className='fs-12 gSemiBold uppercase grey-600 mg-bottom-15'>
                      {info?.heading}
                    </div>
                    <div className='fs-20 gSemiBold txt-center grey-900'>
                      {info?.description}
                    </div>
                  </div>
                  {info?.image && (
                    <img src={info?.image} width={'100%'} alt='feature-image' />
                  )}
                  <div className='center justify-end px-20'>
                    <div className='fs-12 br30 gBold txt-center included sb-blue-bg-100 center'>
                      INCLUDED
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        );
      })}
    </BaseSlider>
  );
}
